<template>
  <section id="packages" class="operators">
    <div class="container" data-aos="fade-up">
      <div class="section-title">
        <h2>Packages</h2>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 operator-filter">
          <select class="form-control" @change="onChangeOperator">
            <option value="all">All Operators</option>
            <option value="gp">Grameenphone</option>
            <option value="robi">Robi</option>
            <option value="airtel">Airtel</option>
            <option value="bl">Banglalink</option>
            <option value="teletalk">Teletalk</option>
          </select>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 margin-top-sm-5">
          <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <!--          <li class="nav-item" role="presentation">-->
            <!--            <a class="nav-link" data-toggle="pill" href="#" role="tab" aria-controls="pills-home" aria-selected="true">Grameenphone</a>-->
            <!--          </li>-->
            <!--          <li class="nav-item" role="presentation">-->
            <!--            <a class="nav-link" data-toggle="pill" href="#" role="tab" aria-controls="pills-profile" aria-selected="false" @click="internet">Robi</a>-->
            <!--          </li>-->
            <!--          <li class="nav-item" role="presentation">-->
            <!--            <a class="nav-link" data-toggle="pill" href="#" role="tab" aria-controls="pills-profile" aria-selected="false" @click="internet">Airtel</a>-->
            <!--          </li>-->
            <!--          <li class="nav-item" role="presentation">-->
            <!--            <a class="nav-link" data-toggle="pill" href="#" role="tab" aria-controls="pills-profile" aria-selected="false" @click="internet">Teletalk</a>-->
            <!--          </li>-->
            <!--          <li class="nav-item" role="presentation">-->
            <!--            <a class="nav-link" data-toggle="pill" href="#" role="tab" aria-controls="pills-profile" aria-selected="false" @click="internet">Banglalink</a>-->
            <!--          </li>-->
            <li class="nav-item" role="presentation" style="margin-left: auto;">
              <a class="nav-link active" id="pills-home-tab" data-toggle="pill" href="#talktime" role="tab" aria-controls="pills-home" aria-selected="true" @click="talktime">TALK TIME</a>
            </li>
            <li class="nav-item" role="presentation">
              <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#internet" role="tab" aria-controls="pills-profile" aria-selected="false" @click="internet">INTERNET</a>
            </li>
            <li class="nav-item" role="presentation">
              <a class="nav-link" id="pills-contact-tab" data-toggle="pill" href="#bundle" role="tab" aria-controls="pills-contact" aria-selected="false">BUNDLE</a>
            </li>
          </ul>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade show active" id="talktime" role="tabpanel" aria-labelledby="pills-home-tab">
              <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-3 package" v-for="(pk,index) in talktimes" :key="index" @click="setPackage(pk.operator,pk.connection,pk.amount)">
                  <div class="package-item" v-scroll-to="'#topup'">
                    <div class="d-flex">
                      <img :src="pk.image" class="img-fluid" :alt="pk.name" />
                      <p class="package_name">{{pk.name}}</p>
                      <p class="duration">{{pk.duration}}</p>
                    </div>
                    <div class="d-flex">
                      <p class="connection">{{pk.connection}}</p>
                      <p class="price">{{pk.amount}} Tk.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="internet" role="tabpanel" aria-labelledby="pills-profile-tab">
              <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-3 package" v-for="(pk,index) in internets" :key="index" @click="setPackage(pk.operator,pk.connection,pk.amount)">
                  <div class="package-item" v-scroll-to="'#topup'">
                    <div class="d-flex">
                      <img :src="pk.image" class="img-fluid" :alt="pk.name" />
                      <p class="package_name">{{pk.name}}</p>
                      <p class="duration">{{pk.duration}}</p>
                    </div>
                    <div class="d-flex">
                      <p class="connection">{{pk.connection}}</p>
                      <p class="price">{{pk.amount}} Tk.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="bundle" role="tabpanel" aria-labelledby="pills-contact-tab">
              <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-3 package" v-for="(pk,index) in bundles" :key="index" @click="setPackage(pk.operator,pk.connection,pk.amount)">
                  <div class="package-item" v-scroll-to="'#topup'">
                    <div class="d-flex">
                      <img :src="pk.image" class="img-fluid" :alt="pk.name" />
                      <p class="package_name">{{pk.name}}</p>
                      <p class="duration">{{pk.duration}}</p>
                    </div>
                    <div class="d-flex">
                      <p class="connection">{{pk.connection}}</p>
                      <p class="price">{{pk.amount}} Tk.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- End Skills Section -->
</template>

<script>
import axios from "axios";
export default {
  name: "Packages",
  data() {
    return {
      packages: [],
      popular_packages: [],
      talktimes: [],
      internets: [],
      bundles: [],
      selectedOperator: 'all'
    }
  },
  created() {
    this.packageList();
  },
  methods: {
    packageList() {
      let instance = this;
      axios.get(`${this.apiPath}get-packages`).then(function (response){
        instance.packages = response.data.data
        instance.popular_packages = response.data.data.filter(function (item){
          return item.id === 1 || item.id === 2 || item.id === 3 || item.id === 4;
        });
        instance.$store.commit('setPopularPackage',instance.popular_packages);
        instance.talktime();
        instance.internet();
        instance.bundle();
      }).catch(function (error){
        instance.$toaster.error(error.response.data.message);
      });
    },
    talktime() {
      let instance = this;
      if (this.selectedOperator === 'all') {
        this.talktimes = this.packages.filter(function(item){
          return item.category === 'talktime';
        });
      } else {
        this.talktimes = this.packages.filter(function(item){
          return item.category === 'talktime' && item.operator === instance.selectedOperator;
        });
      }
    },
    internet() {
      let instance = this;
      if (this.selectedOperator === 'all') {
        this.internets = this.packages.filter(function(item){
          return item.category === 'internet';
        });
      } else {
        this.internets = this.packages.filter(function(item){
          return item.category === 'internet' && item.operator === instance.selectedOperator;
        });
      }
    },
    bundle() {
      let instance = this;
      if (this.selectedOperator === 'all') {
        this.bundles = this.packages.filter(function(item){
          return item.category === 'bundle';
        });
      } else {
        this.bundles = this.packages.filter(function(item){
          return item.category === 'bundle' && item.operator === instance.selectedOperator;
        });
      }
    },
    onChangeOperator(event) {
      this.selectedOperator = event.target.value;
      this.talktime();
      this.internet();
      this.bundle();
    },
    setPackage(operator,connection,amount) {
      this.$store.commit('setOperator',operator);
      this.$store.commit('setConnectionType',connection);
      this.$store.commit('setAmount',amount);
    }
  }
};
</script>

<style scoped lang="scss">
.operators img{
  width: 15px;
  height: 15px;
  margin: 1px 10px 0 0;
}
.package {
  cursor: pointer;
  width: 50%;
  margin-bottom: 10px;
}

.package .package-item {
  border: 1px solid #ccc6c6;
  border-radius: 5px;
  padding: 5px;
}

.package-item:hover {
  border: 1px solid #004a59;
}

.package-item:focus {
  border: 1px solid #004a59;
}

.package-item p {
  word-break: break-word;
  font-size: 10px;
  font-weight: bold;
  margin: 1px 0 5px 0;
  letter-spacing: 0.05em;
  text-transform: capitalize;
  text-align: left;
}

.package-item .price {
  margin-left: auto;
  background: #8f2d56;
  border-radius: 3px;
  padding: 1px 5px;
  color: #ffffff;
}
.nav-pills .nav-link.active, .nav-pills .show>.nav-link {
  background: #004a59;
  color: #FFFFFF;
  font-weight: bold;
}
.nav-pills .nav-link {
  color: #004a59;
  font-weight: bold;
}
.packages ul>li {
  margin-left: auto;
}
.package_name {
  width: 75%;
  min-height: 36px;
  margin: 0;
}
.duration {
  color: #838587;
  padding: 2px;
  font-size: 10px !important;
  border: 1px solid #8385874a;
  border-radius: 5px;
}
.operator-filter {
}
.operator-filter select {
  border: 1px solid #004a594d;
  color: #004a59;
  font-weight: bold;
}
@media (max-width: 900px) {
  .margin-top-sm-5 {
    margin-top: 15px;
  }
}
</style>
